import {
  TimeZone3oibfp0mqo4lg as TimeZone,
  toInstant1fmt1re8uidf7 as toInstant,
} from '../TimeZone.mjs';
import {
  LocalDateTime3vqv9moe7clf4 as LocalDateTime,
  plusSeconds2y48czw9c0543 as plusSeconds,
} from '../LocalDateTime.mjs';
import { Companion_getInstance3qlladteis94 as Companion_getInstance } from '../LocalTime.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Overlap7zq5geu1d3zf as Overlap,
  Gapiqt6nuekag60 as Gap,
  Regular3ayyei7bjphdz as Regular,
} from './OffsetInfo.mjs';
import { DateTimeArithmeticException3b9ehoczpp1e2 as DateTimeArithmeticException } from '../Exceptions.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RegionTimeZoneClass;
function RegionTimeZone() {
  if (RegionTimeZoneClass === VOID) {
    class $ extends TimeZone() {
      constructor(tzid, id) {
        return new.target.new_kotlinx_datetime_internal_RegionTimeZone_3oghim_k$(tzid, id);
      }
      static new_kotlinx_datetime_internal_RegionTimeZone_3oghim_k$(tzid, id) {
        var $this = this.new_kotlinx_datetime_TimeZone_unj4p_k$();
        $this.tzid_1 = tzid;
        $this.id_1 = id;
        return $this;
      }
      get_id_kntnx8_k$() {
        return this.id_1;
      }
      atStartOfDay_893z35_k$(date) {
        var ldt = LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(date, Companion_getInstance().MIN_1);
        var info = this.tzid_1.infoAtDatetime_we6d2t_k$(ldt);
        var tmp;
        if (info instanceof Regular()) {
          tmp = toInstant(ldt, info.offset_1);
        } else {
          if (info instanceof Gap()) {
            tmp = info.start_1;
          } else {
            if (info instanceof Overlap()) {
              tmp = toInstant(ldt, info.offsetBefore_1);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
        return tmp;
      }
      localDateTimeToInstant_1g6wu_k$(dateTime, preferred) {
        var info = this.tzid_1.infoAtDatetime_we6d2t_k$(dateTime);
        var tmp;
        if (info instanceof Regular()) {
          tmp = toInstant(dateTime, info.offset_1);
        } else {
          if (info instanceof Gap()) {
            var tmp_0;
            try {
              tmp_0 = toInstant(plusSeconds(dateTime, info.get_transitionDurationSeconds_pn5o5p_k$()), info.offsetAfter_1);
            } catch ($p) {
              var tmp_1;
              if ($p instanceof IllegalArgumentException()) {
                var e = $p;
                throw DateTimeArithmeticException().new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$('Overflow whet correcting the date-time to not be in the transition gap', e);
              } else {
                throw $p;
              }
            }
            tmp = tmp_0;
          } else {
            if (info instanceof Overlap()) {
              tmp = toInstant(dateTime, info.offsetAfter_1.equals(preferred) ? info.offsetAfter_1 : info.offsetBefore_1);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
        return tmp;
      }
      offsetAtImpl_umwonf_k$(instant) {
        return this.tzid_1.infoAtInstant_1jk5uc_k$(instant);
      }
    }
    initMetadataForClass($, 'RegionTimeZone');
    RegionTimeZoneClass = $;
  }
  return RegionTimeZoneClass;
}
//region block: exports
export {
  RegionTimeZone as RegionTimeZoneqfwrnej6ijxi,
};
//endregion

//# sourceMappingURL=RegionTimeZone.mjs.map
